import { render, staticRenderFns } from "./modal-manager.vue?vue&type=template&id=f1a42460&scoped=true"
import script from "./modal-manager.vue?vue&type=script&setup=true&lang=js"
export * from "./modal-manager.vue?vue&type=script&setup=true&lang=js"
import style0 from "./modal-manager.vue?vue&type=style&index=0&id=f1a42460&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a42460",
  null
  
)

export default component.exports